var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#5F6F7C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6111 13.3333H17.0556L17.0556 16.8333H18.6111V13.3333ZM20.1667 14.5V12.1667C20.1667 11.5223 19.4702 11 18.6111 11H17.0556C16.1964 11 15.5 11.5223 15.5 12.1667V14.5H13.1667C12.5223 14.5 12 15.0223 12 15.6667V18.5833V21.5V22.6667V25.5833V26.75V30.8333C12 31.4777 12.5223 32 13.1667 32H31.8333C32.4777 32 33 31.4777 33 30.8333V26.75V25.5833V22.6667V21.5V18.5833V15.6667C33 15.0223 32.4777 14.5 31.8333 14.5H29.5V12.1667C29.5 11.5223 28.8036 11 27.9444 11H26.3889C25.5298 11 24.8333 11.5223 24.8333 12.1667V14.5H20.1667ZM30.6667 21.5V18.5833L27.75 18.5833V21.5H30.6667ZM23.0833 18.5833H26.5833V21.5H23.0833V18.5833ZM21.9167 18.5833V21.5H18.4167V18.5833H21.9167ZM21.9167 22.6667H18.4167V25.5833H21.9167V22.6667ZM21.9167 26.75H18.4167V29.6667H21.9167V26.75ZM23.0833 29.6667V26.75H26.5833V29.6667H23.0833ZM23.0833 25.5833V22.6667H26.5833V25.5833H23.0833ZM27.75 26.75V29.6667H30.6667V26.75H27.75ZM27.75 22.6667V25.5833H30.6667V22.6667H27.75ZM17.25 21.5V18.5833L14.3333 18.5833V21.5H17.25ZM14.3333 22.6667H17.25V25.5833H14.3333V22.6667ZM14.3333 29.6667V26.75H17.25V29.6667H14.3333ZM27.9444 13.3333V16.8333H26.3889V13.3333H27.9444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleIcon);
export default __webpack_public_path__ + "static/media/schedule-icon.438ce7aa389db0544f832e6000479a13.svg";
export { ForwardRef as ReactComponent };